<template>
  <div class="app-container">
    <img class="img" :src="error" />
    <p class="err-title">{{errorMessage}}</p>
    <div :class="`${hasClick?'hasclick-btn':'err-btn'}`" @click="createdOrder()">重新提交</div>
  </div>
</template>

<script>
import error from '@/assets/img/order/error.png'
import { createOrder } from '@/api/order'
import sasdk from './sasdkinit'
import { ORDERLIST } from '@/config/masterorder.js'
export default {
  data () {
    return {
      error,
      errorMessage: this.$route.query.errorMessage,
      hasClick: false
    }
  },
  mounted () {
    sasdk.viewfail()
  },
  methods: {
    createdOrder () {
      this.hasClick = true
      createOrder({
        studentId: this.$route.query.studentId,
        couponCode: this.$route.query.couponCode,
        masterId: this.$route.query.masterId,
        secondChannel: this.$route.query.secondChannel,
        stId: this.$route.query.stId,
        stageId: this.$route.query.stageId
      }).then(res => {
        this.hasClick = false
        if (res.code !== 200) {
          switch (res.code) {
            case 1000013:
              this.errorMessage = '您的班主任席位不足，请联系班主任增加席位'
              break
            case 100003:
            case 100005:
            case 100006:
            case 100007:
            case 100008:
            case 100009:
            case 1000018:
              this.errorMessage = '课程已下架不能购买'
              break
            case 1000017:
              this.errorMessage = '您以及购买该课期，不能重复购买'
              break
            default:
              this.errorMessage = `订单创建失败，错误码${res.code}`
              break
          }
        } else {
          window.location.href = ORDERLIST
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  min-height: 100vh;
  background: #FFFFFF;
  overflow: hidden;
  position: absolute;
  top: 242px;
  left: 50%;
  transform: translateX(-50%);
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.img {
  width: 300px;
  height: 300px;
}
.err-title {
  height: 32px;
  font-size: 32px;
  font-weight: 400;
  color: #333333;
  line-height: 32px;
  margin-top: 10px;
  text-align: center;
}
.err-btn {
  width: 172px;
  height: 64px;
  border-radius: 35px;
  border: 2px solid #FF6422;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
  color: #FF6422;
  line-height: 64px;
  margin: 32px auto 0 auto;
}
.hasclick-btn {
  cursor: not-allowed;
  width: 172px;
  height: 64px;
  border-radius: 35px;
  border: 2px solid #c4bfbd;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
  color: #c4bfbd;
  line-height: 64px;
  margin: 32px auto 0 auto;
}
</style>
